import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AboutImg1 from "../Assets/img/about-page/about-img-1.jpg";

import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import ReslutsImg from "../Assets/img/results-img.jpg";
import Icon2 from "../Assets/img/school-information-icon/icon-1.svg";
import Awards from "../Components/Awards";
import CornerMessage from "../Components/CornerMessage";
import Glance from "../Components/Glance";
import SchoolEnvironment from "../Components/SchoolEnvironment";
const AboutUs = () => {
  const [aboutInfo, setAboutInfo] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [currentMenu, setCurrentMenu] = useState("eschool-corner-message");

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get("JSON/about.json").then((response) => {
      setAboutInfo(response.data[0]);
    });
  }, []);

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset >= 1000 && window.pageYOffset <= 2799) {
      setIsVisible(true);
      setCurrentMenu("eschool-corner-message");
    } else if (2800 <= window.pageYOffset && window.pageYOffset <= 4300) {
      setIsVisible(true);
      setCurrentMenu("eschool-at-glance");
    } else if (4301 <= window.pageYOffset && window.pageYOffset <= 5150) {
      setIsVisible(true);
      setCurrentMenu("school-information-area");
    } else if (5151 <= window.pageYOffset && window.pageYOffset <= 6370) {
      setIsVisible(true);
      setCurrentMenu("school-infrastructure-area");
    } else if (6371 <= window.pageYOffset && window.pageYOffset <= 7900) {
      setIsVisible(true);
      setCurrentMenu("eschool-award-area");
    } else if (7901 <= window.pageYOffset && window.pageYOffset <= 8321) {
      setIsVisible(true);
      setCurrentMenu("our-mission");
    } else if (8322 <= window.pageYOffset && window.pageYOffset <= 8800) {
      setIsVisible(true);
      setCurrentMenu("our-vission");
    } else {
      setIsVisible(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
  }, [window.pageYOffset, currentMenu]);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">About Us</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i className="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/aboutus">About Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="aboutus-page-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6  col-12">
              <div className="about-page-sec-content">
                <h4 className="about-page-sec-sm-cont-title">About Us</h4>
                <h3 className="about-page-sec-big-cont-title">
                  {aboutInfo?.about_title}
                </h3>
                <p className="about-page-sec-text">{aboutInfo?.about_detail}</p>

                <div className="about-page-sec-btn">
                  <a
                    href={aboutInfo?.file}
                    className="eschool-btn secondary-btn"
                    download
                  >
                    Download school boucher<i className="fi fi-sr-download"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="about-page-sec-img">
                <img src={AboutImg1} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className={
          isVisible ? "about-section-menu is-sticky" : "about-section-menu "
        }
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="about-section-menu-list">
                <li>
                  <a
                    href="#eschool-corner-message"
                    className={
                      currentMenu === "eschool-corner-message"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    Corner message
                  </a>
                </li>
                <li>
                  <a
                    href="#eschool-at-glance"
                    className={
                      currentMenu === "eschool-at-glance"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    At a glance
                  </a>
                </li>
                <li>
                  <a
                    href="#school-information-area"
                    className={
                      currentMenu === "school-information-area"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    School Information
                  </a>
                </li>
                <li>
                  <a
                    href="#school-infrastructure-area"
                    className={
                      currentMenu === "school-infrastructure-area"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    School Infrastructure
                  </a>
                </li>
                <li>
                  <a
                    href="#eschool-award-area"
                    className={
                      currentMenu === "eschool-award-area"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    Awards
                  </a>
                </li>
                <li>
                  <a
                    href="#our-mission"
                    className={
                      currentMenu === "our-mission"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    Mission
                  </a>
                </li>
                <li>
                  <a
                    href="#our-vission"
                    className={
                      currentMenu === "our-vission"
                        ? "about-section-menu-list-active"
                        : ""
                    }
                  >
                    Vission
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section id="eschool-corner-message" className="eschool-corner-message">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <CornerMessage />
            </div>
          </div>
        </div>
      </section>

      <section
        id="eschool-at-glance"
        className={
          currentMenu === "eschool-at-glance"
            ? "eschool-at-glance about-section-active"
            : "eschool-at-glance"
        }
      >
        <Glance />
      </section>

      <section
        id="school-information-area"
        className={
          currentMenu === "school-information-area"
            ? "school-information-area about-section-active"
            : "school-information-area"
        }
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="section-head">
                <h3 className="section-head-title">School information</h3>
                <p className="section-head-text">
                  Collaboratively simplify user friendly networks after
                  principle centered coordinate effective methods of empowerment
                  distributed niche markets pursue market positioning
                  web-readiness after resource sucking applications.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="school-information-tab-area">
                <div className="row">
                  <div className="col-12">
                    {/* <!-- Tab Menu --> */}
                    <div className="school-information-tab-menu">
                      <div className="list-group" id="list-tab" role="tablist">
                        <a
                          className="list-group-item active"
                          data-bs-toggle="list"
                          href="#basic-information"
                          role="tab"
                        >
                          Basic information
                        </a>
                        <a
                          className="list-group-item"
                          data-bs-toggle="list"
                          href="#psc-exam"
                          role="tab"
                        >
                          PSC exam results
                        </a>
                        <a
                          className="list-group-item"
                          data-bs-toggle="list"
                          href="#jsc-exam"
                          role="tab"
                        >
                          JSC exam results
                        </a>
                        <a
                          className="list-group-item"
                          data-bs-toggle="list"
                          href="#ssc-exam"
                          role="tab"
                        >
                          SSC exam results
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    {/* <!-- Tab Details --> */}
                    <div className="school-information-tab-details">
                      <div className="tab-content" id="nav-tabContent">
                        {/* <!-- Tab One --> */}
                        <div
                          className="tab-pane fade show active"
                          id="basic-information"
                          role="tabpanel"
                        >
                          <div className="school-info-tab-details-single">
                            <div className="row align-items-center">
                              <div className="col-lg-12 col-xl-5 col-12">
                                <div className="school-info-tab-details-content">
                                  <p className="school-info-tab-details-cont-text">
                                    it is a long established fact that a reader
                                    will be distracted by the readable content
                                    of a page when looking at its layout. The
                                    point of using Lorem Ipsum is that it has a
                                    more-or-less normal distribution of letters,
                                    as opposed to using 'Content here, content
                                    here', making it look like readable English.
                                  </p>
                                  <p className="school-info-tab-details-cont-text m-0">
                                    Many desktop publishing packages and web
                                    page editors now use Lorem Ipsum as their
                                    default model text, and a search for 'lorem
                                    ipsum' will uncover many web sites still in
                                    their infancy. Various versions have evolved
                                    over the years, sometimes by accident,
                                    sometimes on purpose (injected humour and
                                    the like).
                                  </p>
                                  <div className="school-info-eiin-number">
                                    <i className="fi fi-rr-shield-check"></i>
                                    <div className="school-info-eiin-number-main">
                                      <h5>School EIIN Number :</h5>
                                      <h4>202233</h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 col-xl-7  col-12">
                                <div className="school-info-tab-details-card-area">
                                  <div className="row">
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            200
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Total Students
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            120
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Male Students
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            80
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Female Students
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            15
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Total Teacher
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            10
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Male Teacher
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            10
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Female Teacher
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            02
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Office Staff
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            12
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            Total Classroom
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-12">
                                      <div className="school-info-details-card-single">
                                        <div className="school-info-details-card-icon">
                                          <img src={Icon2} alt="#" />
                                        </div>
                                        <div className="school-info-details-card-content">
                                          <h3 className="school-info-details-card-total">
                                            02
                                          </h3>
                                          <h4 className="school-info-details-card-title">
                                            School Buildings
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- Tab Two --> */}
                        <div
                          className="tab-pane fade"
                          id="psc-exam"
                          role="tabpanel"
                        >
                          <div className="school-info-tab-details-single">
                            <div className="row ">
                              <div className="col-lg-12 col-xl-6 col-12">
                                <div className="school-info-tab-details-img-area">
                                  <div className="school-info-tab-details-img">
                                    <img src={ReslutsImg} alt="#" />
                                  </div>
                                  <p className="school-info-tab-details-img-text">
                                    It is a long established fact that a reader
                                    will be distracted by the readable content
                                    of a page when looking at its layout. The
                                    point of using Lorem Ipsum is that it has a
                                    more-or-less normal distribution of letters,
                                    as opposed to using 'Content here, content
                                    here', making it look like readable English.
                                    Many desktop publishing packages and web.
                                  </p>
                                  <p className="school-info-tab-details-img-text m-0">
                                    {" "}
                                    Many desktop publishing packages and web
                                    page editors now use Lorem Ipsum as their
                                    default model text, and a search for 'lorem
                                    ipsum' will uncover many web sites still in
                                    their infancy. Various versions have evolved
                                    over the years, sometimes by accident,
                                    sometimes on purpose (injected humour and
                                    the like).
                                  </p>
                                </div>
                              </div>
                              <div className="col-lg-12 col-xl-6 col-12">
                                <div className="school-info-tab-details-results">
                                  <h4 className="school-info-tab-d-results-title">
                                    Results History
                                  </h4>
                                  <div className="school-info-tab-d-results-main">
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        PSC exam 2018
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        70%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        30%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        PSC exam 2019
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        90%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        PSC exam 2020
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        60%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        PSC exam 2021
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        PSC exam 2022
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        60%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- Tab Three --> */}
                        <div
                          className="tab-pane fade"
                          id="jsc-exam"
                          role="tabpanel"
                        >
                          <div className="school-info-tab-details-single">
                            <div className="row ">
                              <div className="col-lg-12 col-xl-6 col-12">
                                <div className="school-info-tab-details-img-area">
                                  <div className="school-info-tab-details-img">
                                    <img src={ReslutsImg} alt="#" />
                                  </div>
                                  <p className="school-info-tab-details-img-text">
                                    It is a long established fact that a reader
                                    will be distracted by the readable content
                                    of a page when looking at its layout. The
                                    point of using Lorem Ipsum is that it has a
                                    more-or-less normal distribution of letters,
                                    as opposed to using 'Content here, content
                                    here', making it look like readable English.
                                    Many desktop publishing packages and web.
                                  </p>
                                  <p className="school-info-tab-details-img-text m-0">
                                    {" "}
                                    Many desktop publishing packages and web
                                    page editors now use Lorem Ipsum as their
                                    default model text, and a search for 'lorem
                                    ipsum' will uncover many web sites still in
                                    their infancy. Various versions have evolved
                                    over the years, sometimes by accident,
                                    sometimes on purpose (injected humour and
                                    the like).
                                  </p>
                                </div>
                              </div>
                              <div className="col-lg-12 col-xl-6 col-12">
                                <div className="school-info-tab-details-results">
                                  <h4 className="school-info-tab-d-results-title">
                                    Results History
                                  </h4>
                                  <div className="school-info-tab-d-results-main">
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        JSC exam 2018
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        70%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        30%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        JSC exam 2019
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        90%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        JSC exam 2020
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        60%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        JSC exam 2021
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        JSC exam 2022
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        60%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- Tab Four --> */}
                        <div
                          className="tab-pane fade"
                          id="ssc-exam"
                          role="tabpanel"
                        >
                          <div className="school-info-tab-details-single">
                            <div className="row ">
                              <div className="col-lg-12 col-xl-6 col-12">
                                <div className="school-info-tab-details-img-area">
                                  <div className="school-info-tab-details-img">
                                    <img src={ReslutsImg} alt="#" />
                                  </div>
                                  <p className="school-info-tab-details-img-text">
                                    It is a long established fact that a reader
                                    will be distracted by the readable content
                                    of a page when looking at its layout. The
                                    point of using Lorem Ipsum is that it has a
                                    more-or-less normal distribution of letters,
                                    as opposed to using 'Content here, content
                                    here', making it look like readable English.
                                    Many desktop publishing packages and web.
                                  </p>
                                  <p className="school-info-tab-details-img-text m-0">
                                    {" "}
                                    Many desktop publishing packages and web
                                    page editors now use Lorem Ipsum as their
                                    default model text, and a search for 'lorem
                                    ipsum' will uncover many web sites still in
                                    their infancy. Various versions have evolved
                                    over the years, sometimes by accident,
                                    sometimes on purpose (injected humour and
                                    the like).
                                  </p>
                                </div>
                              </div>
                              <div className="col-lg-12 col-xl-6 col-12">
                                <div className="school-info-tab-details-results">
                                  <h4 className="school-info-tab-d-results-title">
                                    Results History
                                  </h4>
                                  <div className="school-info-tab-d-results-main">
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        SSC exam 2018
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        70%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        30%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        SSC exam 2019
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        90%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        SSC exam 2020
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        60%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        SSC exam 2021
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        50%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                    <div className="school-info-tab-d-results-single">
                                      <p className="school-info-tab-exam-name">
                                        SSC exam 2022
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Male</span>
                                        60%
                                      </p>
                                      <p className="school-info-tab-exam-male-female">
                                        <span>Female</span>
                                        40%
                                      </p>
                                      <p className="school-info-tab-exam-avg-results">
                                        <span>Avg. results</span>
                                        100%
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- End Tab Details --> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="school-infrastructure-area"
        className={
          currentMenu === "school-infrastructure-area"
            ? "school-infrastructure-area about-section-active"
            : "school-infrastructure-area"
        }
      >
        <SchoolEnvironment />
      </section>

      <section
        id="eschool-award-area"
        className={
          currentMenu === "eschool-award-area"
            ? "eschool-award-area about-section-active"
            : "eschool-award-area"
        }
      >
        <Awards />
      </section>

      <section className="eschool-mission-vission-area">
        <div className="container">
          <div
            id="our-mission"
            className={
              currentMenu === "our-mission"
                ? "mission-vission-section about-section-active"
                : "mission-vission-section"
            }
          >
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <div className="mission-vission-img">
                  <img src="https://via.placeholder.com/656x420" alt="#" />
                </div>
              </div>
              <div className="col-lg-6  col-12">
                <div className="mission-vission-content">
                  <h3 className="mission-vission-cont-title">Our Mission</h3>
                  <p className="mission-vission-cont-text">
                    it is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout. The point of using Lorem Ipsum is that it has a
                    more-or-less normal distribution of letters, as opposed to
                    using 'Content here, content here', making it look like
                    readable English. Many desktop publishing packages and web
                    page editors now use Lorem Ipsum as their default model
                    text.
                  </p>
                  <p className="mission-vission-cont-text m-0">
                    Many desktop publishing packages and web page editors now
                    use Lorem Ipsum as their default model text, and a search
                    for 'lorem ipsum' will uncover many web sites still in their
                    infancy. Various versions have evolved over the years,
                    sometimes by accident, sometimes on purpose (injected humour
                    and the like).
                  </p>
                  <div className="s-mission-vission-cont-btn">
                    <a className="eschool-btn secondary-btn" href="/aboutus">
                      Read more<i className="fi fi-rr-plus"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="our-vission"
            className={
              currentMenu === "our-vission"
                ? "mission-vission-section about-section-active"
                : "mission-vission-section"
            }
          >
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <div className="mission-vission-content">
                  <h3 className="mission-vission-cont-title">Our Vission</h3>
                  <p className="mission-vission-cont-text">
                    it is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout. The point of using Lorem Ipsum is that it has a
                    more-or-less normal distribution of letters, as opposed to
                    using 'Content here, content here', making it look like
                    readable English. Many desktop publishing packages and web
                    page editors now use Lorem Ipsum as their default model
                    text.
                  </p>
                  <p className="mission-vission-cont-text m-0">
                    Many desktop publishing packages and web page editors now
                    use Lorem Ipsum as their default model text, and a search
                    for 'lorem ipsum' will uncover many web sites still in their
                    infancy. Various versions have evolved over the years,
                    sometimes by accident, sometimes on purpose (injected humour
                    and the like).
                  </p>
                  <div className="s-mission-vission-cont-btn">
                    <a className="eschool-btn secondary-btn" href="/aboutus">
                      Read more<i className="fi fi-rr-plus"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="mission-vission-img">
                  <img src="https://via.placeholder.com/656x420" alt="#" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
